import {TemplateItemMapper, DefaultTemplateItemMapper, RemoveTemplateItemMapper, TemplateMapper} from "./templating";
import {format} from "date-fns";
import {AlertType} from "./default-constants";
import {v4} from "uuid";

class AlertClass {
	#confirmModal = null;
	#alertModal = null;

	constructor() {
		if (window.AlertClass) {
			return window.AlertClass;
		}
		window.AlertClass = this;
		$("document").ready(() => this.init());
	}

	init() {
		this.loadedToasts = [];
	}

	/**
	 *
	 * @param parameters :ToastParameters
	 */
	showToast({header, message, alertType, additionalCssClass, autohide, delayMs, events, uniqueId}) {
		let mainId = v4();
		let validationId = uniqueId ?? mainId;
		
		if (!this.loadedToasts.find(item => item.validationId === validationId)) {

			let template = $(
				'<div data-id="pnlToast" class="toast" role="alert" aria-live="assertive" aria-atomic="true">' +
				'<div class="toast-header" data-id="pnlToastHeader">' +
				'<i data-id="icoAlertType" class="mr-2"></i>' +
				'<strong class="me-auto" data-id="pnlToastHeaderContent"></strong>' +
				// '<small class="text-muted" id="">just now</small>' +
				'<button type="button" class="btn-close" data-bs-dismiss="toast" aria-label="Close"></button>' +
				'</div>' +
				'<div class="toast-body" data-id="pnlToastBody"></div>' +
				'</div>');

			let mappers = [
				new DefaultTemplateItemMapper(),
				new TemplateItemMapper('[data-id="icoAlertType"]', (o, c) => {
					o.addClass(c.alertType.toastIcon);
				}),
				new TemplateItemMapper('[data-id="pnlToastHeader"]', (o, c) => {
					o.addClass(c.alertType.toastClass);
				}),
				new TemplateItemMapper('[data-id="pnlToastHeaderContent"]', (o, c) => {
					o.html(c.header);
				}),
				new TemplateItemMapper('[data-id="pnlToastBody"]', (o, c) => {
					o.html(c.message);
				}),
				new TemplateItemMapper('[data-id="pnlToast"]', (o, c) => {
					o.width(300).addClass(c.additionalCssClass);
				})
			];

			let results = new TemplateMapper().executeLayout(template, {
				templateMappings: mappers,
				context: {
					mainId: mainId,
					header,
					message,
					additionalCssClass,
					alertType: alertType
				}
			});
			let toast = new bootstrap.Toast(results[0], {
				autohide: autohide,
				delay: delayMs
			});
			this.loadedToasts.push({
				validationId: validationId,
				toast: toast
			});

			$("#pnlToast").append(results);
			toast.show();
		}

		//
		//
		// if (events) {
		// 	results
		// 		.on('show.bs.toast', (e) => events.onShowToast(e))
		// 		.on('shown.bs.toast', (e) => events.onShownToast(e))
		// 		.on('hide.bs.toast', (e) => events.onHideToast(e))
		// 		.on('hidden.bs.toast', (e) => {
		// 			events.onHiddenToast(e)
		// 		}).toast('show');
		// }
	}

	/**
	 *
	 * @param parameters : ConfirmParameters
	 */
	promisifiedConfirm({header, message, okLabelText, cancelLabelText}) {

		return new Promise((resolve, reject) => {
			let events = {
				onShowModal: () => {
				},
				onShownModal: () => {
				},
				onHideModal: () => {
				},
				onHidePreventedModal: () => {
				},
				onHiddenModal: (e) => {
					let obj = $("#pnlModalStaticConfirmBackdrop");
					resolve(obj.data('isConfirmed'));
				}
			}

			this.confirm(new ConfirmParameters({header, message, events, okLabelText, cancelLabelText}));
		})
	}

	/**
	 *
	 * @param parameters : ConfirmParameters
	 */
	confirm(parameters) {
		let {header, message, onOkClick, events, okLabelText, cancelLabelText} = parameters;

		if (!this.#confirmModal) {
			let confirmModal = $(
				'<div class="modal fade" id="pnlModalStaticConfirmBackdrop" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="lblStaticBackdrop" aria-hidden="true">' +
				'<div class="modal-dialog">' +
				'<div class="modal-content">' +
				'<div class="modal-header">' +
				`<h5 class="modal-title" id="lblStaticBackdrop">${header}</h5>` +
				'</div>' +
				'<div class="modal-body">' +
				`${message}` +
				'</div>' +
				'<div class="modal-footer">' +
				`<button type="button" id="btnConfirmModalSuccess" class="btn btn-primary" data-bs-dismiss="modal">${okLabelText}</button>` +
				`<button type="button" id="btnConfirmModalClose" class="btn btn-outline-danger" data-bs-dismiss="modal">${cancelLabelText}</button>` +
				'</div>' +
				'</div>' +
				'</div>' +
				'</div>');

			confirmModal.modal().find('#btnConfirmModalSuccess').on('click', async (e) => {
				if (onOkClick) {
					await onOkClick(e);
				}
				this.#confirmModal.data('isConfirmed', true).modal('hide');
			});

			if (events) {
				confirmModal
					.on('show.bs.modal', (e) => {
						events.onShowModal(e);
					})
					.on('shown.bs.modal', (e) => {
						events.onShownModal(e);
					})
					.on('hide.bs.modal', (e) => {
						events.onHideModal(e);
					})
					.on('hidden.bs.modal', (e) => {
						events.onHiddenModal(e);
					})
					.on('hidePrevented.bs.modal', (e) => {
						events.onHidePreventedModal(e)
					});
			}

			$("body").append(confirmModal);
			this.#confirmModal = confirmModal;
		}
		this.#confirmModal.data('isConfirmed', false);
		this.#confirmModal.modal('show');

	}

	promisifiedAlert({header, message, okLabelText}) {
		return new Promise((resolve, reject) => {
			let events = {
				onShowModal: () => {
				},
				onShownModal: () => {
				},
				onHideModal: () => {
				},
				onHiddenModal: (e) => {
					return resolve($("#pnlModalStaticAlertBackdropMessages").data("isConfirmed"))
				},
				onHidePreventedModal: () => {
				},
			};
			this.alert({header, message, events, okLabelText})
		})
	}

	alert({header, message, onOkClick, events, okLabelText, btnCloseClass}) {
		let modalObject = $("#alertModal");
		let alertModal = new bootstrap.Modal('#alertModal');

		modalObject.find('#alertModalTitle').html(header);
		modalObject.find('#alertModalBody').html(message);
		modalObject.find('#btnClose').text(okLabelText ?? "Ok").addClass(btnCloseClass ?? "btn-secondary");
		// modalObject.find('#btnClose').on('click', (e) => {
		// 	if (onOkClick) {
		// 		onOkClick(e);
		// 	}
		// 	this.#alertModal.data('isConfirmed', true).modal('hide');
		// });
		//
		alertModal.show();
	}

	alert_old({header, message, onOkClick, events, okLabelText}) {

		if (!this.#alertModal) {
			let alertModal = $(
				'<div class="modal fade" id="pnlModalStaticAlertBackdrop" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="lblStaticAlertBackdrop" aria-hidden="true">' +
				'<div class="modal-dialog">' +
				'<div class="modal-content">' +
				'<div class="modal-header">' +
				`<h5 class="modal-title" id="lblStaticAlertBackdrop">${header}</h5>` +
				'<button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">' +
				'<span aria-hidden="true">&times;</span>' +
				'</button>' +
				'</div>' +
				'<div class="modal-body" id="pnlModalStaticAlertBackdropMessages">' +
				'</div>' +
				'<div class="modal-footer">' +
				`<button type="button" id="btnConfirmModalSuccess" class="btn btn-info" data-bs-dismiss="modal">${okLabelText}</button>` +
				'</div>' +
				'</div>' +
				'</div>' +
				'</div>');

			alertModal.modal().find('#btnConfirmModalSuccess').on('click', (e) => {
				if (onOkClick) {
					onOkClick(e);
				}
				this.#alertModal.data('isConfirmed', true).modal('hide');
			});
			if (events) {
				alertModal
					.on('show.bs.modal', events.onShowModal)
					.on('shown.bs.modal', events.onShownModal)
					.on('hide.bs.modal', events.onHideModal)
					.on('hidden.bs.modal', events.onHiddenModal)
					.on('hidePrevented.bs.modal', events.onHidePreventedModal);
			}
			$("body").append(alertModal);
			this.#alertModal = alertModal;
		}

		$('#pnlModalStaticAlertBackdropMessages').html(message);

		this.#alertModal.data('isConfirmed', false).modal('show');

	}

}

class ConfirmParameters {
	constructor({
					header,
					message,
					onOkClick,
					okLabelText = 'Sim',
					cancelLabelText = 'Cancelar',
					events = {
						onShowModal: (e) => {
						},
						onShownModal: (e) => {
						},
						onHideModal: (e) => {
						},
						onHiddenModal: (e) => {
						},
						onHidePreventedModal: (e) => {
						}
					}
				}) {
		this.header = header;
		this.message = message;
		this.onOkClick = onOkClick;
		this.okLabelText = okLabelText;
		this.cancelLabelText = cancelLabelText;
		this.events = events;
	}

	header;
	message;
	onOkClick;
	okLabelText;
	cancelLabelText;
	events;
}

class ToastParameters {
	constructor({
					header, message, alertType, additionalCssClass, autohide = true, delayMs = 1000, onShowToast,
					onShownToast,
					onHideToast,
					onHiddenToast
				}) {
		this.header = header;
		this.message = message;
		this.alertType = alertType ?? AlertType.SUCCESS;
		this.additionalCssClass = additionalCssClass;
		this.autohide = autohide;
		this.delayMs = delayMs;
		this.events = {
			onShowToast: onShowToast ?? function (e) {
			},
			onShownToast: onShownToast ?? function (e) {
			},
			onHideToast: onHideToast ?? function (e) {
			},
			onHiddenToast: onHiddenToast ?? function (e) {
			},
		};
	}

	header;
	message;
	alertType;
	additionalCssClass;
	autohide = true;
	delayMs = 1000;
	events;
}

export {ConfirmParameters, ToastParameters}
export const Alert = new AlertClass();
